<template>
  <v-card flat>
    <v-container>
      <div class="">
        <h3 class="earth-color">EXRA PRICE/SUPPLEMENT</h3>
      </div>
      <v-form @submit.prevent="addExtraPricing()">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Name"
                v-model="extra_pricing.facility_extra_pricing_name"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Select Currency"
                v-model="extra_pricing.currency_type"
                :items="allCurrencyTypes"
                :rules="[v => !!v || 'Currency is required']"
                required
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Amount"
                v-model="extra_pricing.amount"
              ></v-text-field>
            </v-container>
          </v-flex>

          <v-flex lg12 md12 sm12 xs12>
            <v-container>
              <v-btn :depressed="true" color="primary" type="submit"
                >ADD EXTRA PRICE
              </v-btn>
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
      <table cellpadding="1" cellspacing="1" class="table table-bordered">
        <thead>
          <tr>
            <td>Name</td>
            <td>Currency</td>
            <td>Price</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, key) in facilityExtraPricing" :key="key">
            <td>{{ d.facility_extra_pricing_name }}</td>
            <td>{{ d.currency_type }}</td>

            <td>{{ d.amount }} </td>
            <td>
              <v-btn
                :depressed="true"
                color="error"
                small
                @click="deleteExtraPricing(d.public_id)"
                >Disable</v-btn
              >
              <!-- <v-btn
                :depressed="true"
                color="success"
                @click="showEditDialog(d)"
                >Edit</v-btn
              > -->
              <v-dialog
                v-model="edit_facility_extra_pricing"
                persistent
                max-width="700px"
              >
                <v-card>
                  <v-card-title>
                    <h4 class="earth-color">
                      EDIT EXTRA PRICING
                    </h4>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                          <v-text-field
                            label="Name"
                            v-model="
                              edit_extra_pricing.facility_extra_pricing_name
                            "
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-autocomplete
                            label="Select Currency"
                            v-model="edit_extra_pricing.currency_type"
                            :items="allCurrencyTypes"
                            :rules="[v => !!v || 'Currency is required']"
                            required
                            item-text="currency_name"
                            item-value="currency_public_id"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 md6 sm12 xs12>
                          <v-text-field
                            label="Amount"
                            v-model="edit_extra_pricing.amount"
                          ></v-text-field>
                        </v-flex>
                       
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="edit_facility_extra_pricing = false"
                      >Close</v-btn
                    >
                    <v-btn color="green" flat @click="editExtraPricing"
                      >Update</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </td>
          </tr>
        </tbody>
      </table>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "extra-pricing",
  data() {
    return {
      requiredRules: [v => !!v || "This field is required"],
      edit_facility_extra_pricing: false,
      extra_pricing: {
        facility_extra_pricing_name: "",
        currency_type: "",
        amount: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
        facility_id: this.$route.params.facility_id
      },
      edit_extra_pricing: {
        facility_extra_pricing_name: "",
        currency_type: "",
        amount: "",
        public_id:"",
        session_id: localStorage.getItem("lkjhgfdsa"),
        facility_id: this.$route.params.facility_id
      }
    };
  },
  methods: {
    addExtraPricing: function() {
      this.$store.dispatch("post_facility_extra_pricing", this.extra_pricing)
    },
    showEditDialog(d) {
   
      this.edit_facility_extra_pricing = true;
      this.edit_extra_pricing.public_id = d.public_id;

      this.edit_extra_pricing.facility_extra_pricing_name =
        d.facility_extra_pricing_name;

      this.edit_extra_pricing.currency_type =
        d.currency_type;

      this.edit_extra_pricing.amount =
        d.amount;

    },
    editExtraPricing: function() {
      this.edit_facility_extra_pricing = false;
      this.$store.dispatch(
        "edit_facility_extra_pricing",
        this.edit_extra_pricing
      );
    },

    deleteExtraPricing: function(publicId) {
      var data = {
        public_id: publicId,
        facility_id: this.$route.params.facility_id,
        deleted_by: localStorage.getItem("lkjhgfdsa")
      };
      this.$store.dispatch("delete_a_facility_extra_pricing", data);
      this.$store.dispatch(
        "get_facility_extra_pricing",
        this.$route.params.facility_id
      );
    }
  },
  created() {
    this.$store.dispatch(
      "get_facility_extra_pricing",
      this.$route.params.facility_id
    );
    this.$store.dispatch("get_all_currency_types");
    this.$store.dispatch("get_all_facility_pricing_types");
  }
};
</script>

<style scoped></style>
